import { LogErrors } from './../LogErrors'

import { CheckAccessCode as DLCheckAccessCode, GetSignUpInfo as DLGetSignUpInfo, SaveSignUpInfo as DLSaveSignUpInfo, DeleteSignUpInfo as DLDeleteSignUpInfo } from './../DL/Sessions'


/**
 * 
 * @param {string} accessCode
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const CheckAccessCode = async (accessCode) => {
    try {
        const response = await DLCheckAccessCode(accessCode)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('CheckAccessCode - Sessions BL', error)
        //return { success: false, message: 'errorNetwork' } // Código genérico para errores de red
        return { success: false, message: 'No ha sido posible validar el código de acceso que proporcionaste. Inténtalo nuevamente o inténtalo más tarde.' }
    }
}





/**
 * @param {Array} sessionInfo 
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const UpdateSessionInfo = async (sessionInfo) => {
    try {
        await sessionStorage.setItem('userData', JSON.stringify(sessionInfo))

        return { success: true, data: sessionInfo }
    } catch (error) {
        await LogErrors('UpdateSessionInfo - Session DL', error)
        return { success: false, message: '' }
    }
}

const DeleteSessionInfo = async () => {
    try {
        await sessionStorage.removeItem('userData')
        await sessionStorage.removeItem('settings')

        return { success: true, data: {} }
    } catch (error) {
        await LogErrors('DeleteSessionInfo - Session DL', error)
        return { success: false, message: '' }
    }
}





/**
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const GetSignUpInfo = async () => {
    try {
        const response = await DLGetSignUpInfo()
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('GetSignUpInfo - Sessions BL', error)
        return { success: false, message: '' }
    }
}

/**
 * @param {Array} dataToSave
 * @returns {Object} Resultado del proceso { success: boolean, errors: Object, data: Object }
 */
const SaveSignUpInfo = async (dataToSave) => {
    try {
        const response = await DLSaveSignUpInfo(dataToSave)
        
        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('SaveSignUpInfo - Sessions BL', error)
        return { success: false, message: '' }
    }
}

const DeleteSignUpInfo = async () => {
    try {
        const response = await DLDeleteSignUpInfo()

        if (response.success) {
            return { success: true, data: response.data }
        } else {
            return { success: false, message: response.message }
        }
    } catch (error) {
        await LogErrors('DeleteSignUpInfo - Sessions BL', error)
        return { success: false, message: '' }
    }
}

export { CheckAccessCode, UpdateSessionInfo, DeleteSessionInfo, GetSignUpInfo, SaveSignUpInfo, DeleteSignUpInfo };